import { gql } from '@apollo/client';

export const fetchEntitlementDetailsForAppLinksPPCQuery = gql`
  query fetchEntitlementDetailsForAppLinksPPC($id: String, $transactionAccountId: String) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      entitlementNumber
      id
      latestPeriodEndDate
      latestPeriodStartDate
      transactionAccountId
      edition
      platform
      productId
      productName
      plan
      subscriptionId
      billingFrequency: billingCycle
      cloudSiteHostname
      unitCount
      maxUnitCount: unitCount # adding unitCount as default for maxUnitCount
      activeUsers
      isApp
      billingGroupId
      nextBillingTimestamp
      relatesFromEntitlements {
        entitlementId
        relationshipType
      }
    }
  }
`;
